import { useEffect, useState } from "react";

const navLinks = [
	{ label: "Latar Belakang", href: "#latar" },
	{ label: "Program", href: "#program" },
	{ label: "Lembaga", href: "#target" },
	{ label: "Qurban", href: "#qurban" },
	{ label: "Wakaf", href: "#wakaf" },
	{ label: "Artikel", href: "https://nusaqu.id/artikel", external: true },
];

export default function Navbar() {
	const [scrolled, setScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const handler = () => setScrolled(window.scrollY > 40);
		window.addEventListener("scroll", handler);
		return () => window.removeEventListener("scroll", handler);
	}, []);

	const handleNavClick = (e, href) => {
		setMenuOpen(false);
		if (!href.startsWith("#")) return; // link eksternal → buka normal
		e.preventDefault();
		const el = document.querySelector(href);
		if (el) el.scrollIntoView({ behavior: "smooth" });
	};

	return (
		<nav style={styles.nav(scrolled)}>
			<a
				href="#hero"
				style={styles.logo}
				onClick={(e) => handleNavClick(e, "#hero")}>
				<img src="/masq.png" alt="MASQUDE Logo" style={styles.logoImg} />
			</a>

			{/* Desktop Links */}
			<ul className="nav-desktop-links" style={styles.navList}>
				{navLinks.map((l) => (
					<li key={l.href}>
						<a
							href={l.href}
							style={styles.navLink}
							onClick={(e) => handleNavClick(e, l.href)}
							target={l.external ? "_blank" : undefined}
							rel={l.external ? "noreferrer" : undefined}
							onMouseEnter={(e) => (e.target.style.color = "var(--kuning)")}
							onMouseLeave={(e) => (e.target.style.color = "var(--coklat)")}>
							{l.label}
						</a>
					</li>
				))}
				<li>
					<a
						href="#kontak"
						style={styles.navCta}
						onClick={(e) => handleNavClick(e, "#kontak")}
						onMouseEnter={(e) => {
							e.target.style.background = "var(--coklat2)";
							e.target.style.transform = "translateY(-2px)";
						}}
						onMouseLeave={(e) => {
							e.target.style.background = "var(--coklat)";
							e.target.style.transform = "translateY(0)";
						}}>
						Daftar Sekarang
					</a>
				</li>
			</ul>

			{/* Hamburger */}
			<button
				className="nav-hamburger"
				style={styles.hamburger}
				onClick={() => setMenuOpen(!menuOpen)}
				aria-label="Menu">
				<span style={styles.bar(menuOpen, 0)} />
				<span style={styles.bar(menuOpen, 1)} />
				<span style={styles.bar(menuOpen, 2)} />
			</button>

			{/* Mobile Menu */}
			{menuOpen && (
				<div style={styles.mobileMenu}>
					{navLinks.map((l) => (
						<a
							key={l.href}
							href={l.href}
							style={styles.mobileLink}
							onClick={(e) => handleNavClick(e, l.href)}
							target={l.external ? "_blank" : undefined}
							rel={l.external ? "noreferrer" : undefined}>
							{l.label}
						</a>
					))}
					<a
						href="#kontak"
						style={styles.mobileCta}
						onClick={(e) => handleNavClick(e, "#kontak")}>
						Daftar Sekarang
					</a>
				</div>
			)}
		</nav>
	);
}

const styles = {
	nav: (scrolled) => ({
		position: "fixed",
		top: 0,
		width: "100%",
		zIndex: 200,
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "0.9rem 5%",
		background: "rgba(255,248,232,0.96)",
		backdropFilter: "blur(14px)",
		WebkitBackdropFilter: "blur(14px)",
		borderBottom: "1px solid rgba(123,63,0,0.12)",
		transition: "box-shadow 0.3s",
		boxShadow: scrolled ? "0 4px 24px rgba(123,63,0,0.1)" : "none",
	}),
	logo: { display: "flex", alignItems: "center", textDecoration: "none" },
	logoImg: { height: "38px", objectFit: "contain" },
	navList: {
		listStyle: "none",
		display: "flex",
		gap: "1.6rem",
		alignItems: "center",
		margin: 0,
	},
	navLink: {
		color: "var(--coklat)",
		textDecoration: "none",
		fontSize: "0.88rem",
		fontWeight: 600,
		transition: "color 0.2s",
	},
	navCta: {
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.5rem 1.3rem",
		borderRadius: "8px",
		fontSize: "0.88rem",
		fontWeight: 700,
		textDecoration: "none",
		transition: "all 0.25s",
		display: "inline-block",
	},
	hamburger: {
		flexDirection: "column",
		gap: "5px",
		background: "none",
		border: "none",
		cursor: "pointer",
		padding: "6px",
	},
	bar: (open, i) => ({
		width: "24px",
		height: "2.5px",
		background: "var(--coklat)",
		borderRadius: "2px",
		transition: "all 0.3s",
		transform: open
			? i === 0
				? "rotate(45deg) translate(5px,5px)"
				: i === 2
					? "rotate(-45deg) translate(5px,-5px)"
					: "none"
			: "none",
		opacity: open && i === 1 ? 0 : 1,
	}),
	mobileMenu: {
		position: "absolute",
		top: "100%",
		left: 0,
		right: 0,
		background: "rgba(255,248,232,0.98)",
		backdropFilter: "blur(14px)",
		display: "flex",
		flexDirection: "column",
		padding: "1rem 5% 1.5rem",
		borderBottom: "1px solid rgba(123,63,0,0.12)",
		gap: "0.3rem",
	},
	mobileLink: {
		color: "var(--coklat)",
		textDecoration: "none",
		fontSize: "1rem",
		fontWeight: 600,
		padding: "0.65rem 0",
		borderBottom: "1px solid rgba(123,63,0,0.08)",
	},
	mobileCta: {
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.75rem",
		borderRadius: "8px",
		fontSize: "0.95rem",
		fontWeight: 700,
		textDecoration: "none",
		textAlign: "center",
		marginTop: "0.5rem",
	},
};
